import { render } from "./CategoryItem.vue?vue&type=template&id=234bf1bc&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=234bf1bc&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234bf1bc"]])

export default __exports__